/* eslint-disable no-template-curly-in-string */
import { initReactI18next } from 'react-i18next';

import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/pt-br';
import momentDurationFormatSetup from 'moment-duration-format';
import queryString from 'query-string';
import * as yup from 'yup';

import i18n from 'i18next';
import { getCurrentLanguage } from 'utils/generic';

import autoEnUs from './auto/en-us.json';
import autoEsAr from './auto/es-ar.json';
import autoEsCo from './auto/es-co.json';
import autoEsMx from './auto/es-mx.json';
import autoPtBr from './auto/pt-br.json';
import enUs from './en-us.json';
import esAr from './es-ar.json';
import esCo from './es-co.json';
import esMx from './es-mx.json';
import faqEnUs from './faq/en-us.json';
import faqEsAr from './faq/es-ar.json';
import faqEsCo from './faq/es-co.json';
import faqEsMx from './faq/es-mx.json';
import faqPtBr from './faq/pt-br.json';
import ptBr from './pt-br.json';

export const resources = {
  'pt-BR': {
    translation: {
      ...ptBr,
      ...faqPtBr,
      ...autoPtBr,
    },
  },
  'en-US': {
    translation: {
      ...enUs,
      ...faqEnUs,
      ...autoEnUs,
    },
  },
  'es-AR': {
    translation: {
      ...esAr,
      ...faqEsAr,
      ...autoEsAr,
    },
  },
  'es-CO': {
    translation: {
      ...esCo,
      ...faqEsCo,
      ...autoEsCo,
    },
  },
  'es-MX': {
    translation: {
      ...esMx,
      ...faqEsMx,
      ...autoEsMx,
    },
  },
} as const;

export const init18n = (): any => {
  i18n.use(initReactI18next).init({
    lng: getCurrentLanguage(),
    fallbackLng: 'pt-BR',
    resources,
    interpolation: {
      format(value, format, _lng) {
        if (value instanceof Date) return moment(value).format(format);
        return value;
      },
    },
  });
  return i18n.t.bind(i18n);
};

init18n();

const queryParams = queryString.parse(window.location.search) as { showTranslateKeys: string };
const { showTranslateKeys } = queryParams;

if (showTranslateKeys || showTranslateKeys === null) {
  i18n.changeLanguage('cimode');
}

yup.setLocale({
  mixed: {
    notType: (_ref) => {
      switch (_ref.type) {
        case 'number':
          return 'error.typeNumber';
        case 'string':
          return 'error.typeString';
        default:
          return 'error.typeCustom';
      }
    },
    required: 'error.required',
  },
  number: {
    positive: 'error.positive',
    min: 'error.min/${min}',
    max: 'error.max/${max}',
    moreThan: 'error.moreThan/${value}',
  },
  string: {
    email: 'error.email',
    min: 'error.minChar/${min}',
    max: 'error.maxChar/${max}',
  },
});

momentDurationFormatSetup(moment as any);

moment.updateLocale('pt-br', {
  months: ptBr.months,
  monthsShort: ptBr.monthsShort,
  weekdays: ptBr.weekdays,
  weekdaysShort: ptBr.weekdaysShort,
});

moment.updateLocale('en', {
  months: enUs.months,
  monthsShort: enUs.monthsShort,
  weekdays: enUs.weekdays,
  weekdaysShort: enUs.weekdaysShort,
});

moment.updateLocale('es', {
  months: esCo.months,
  monthsShort: esCo.monthsShort,
  weekdays: esCo.weekdays,
  weekdaysShort: esCo.weekdaysShort,
});

const setMomentLocale = (locale: string) => {
  switch (locale) {
    case 'pt-BR':
      moment.locale('pt-br');
      break;
    case 'en-US':
      moment.locale('en');
      break;
    case 'es-AR':
      moment.locale('es');
      break;
    case 'es-CO':
      moment.locale('es');
      break;
    case 'es-MX':
      moment.locale('es');
      break;

    default:
      moment.locale('en');
      break;
  }
};
setMomentLocale(getCurrentLanguage());

export const changeLanguage = (language: string) => {
  sessionStorage.setItem('@currentLanguage', language);
  i18n.changeLanguage(language);
  setMomentLocale(language);
};
